import { createI18nText } from '@hilma/netina2all';

export const reviewedDeliveryText = createI18nText({
	he: {
		missing: 'חסרים לי מוצרים',
		notMissing: 'קבלתי הכל!',
		modalTitle: 'נשמח לדעת מה חסר לך',
		modalSubtitle: 'כדי שנוכל להשלים את החוסרים בהקדם',
		inputError: 'שדה זה צריך להיות מספר חיובי סביר',
		submit: 'אישור',
		thanksTitle: 'תודה שדיווחת!',
		thanksSubtitle: 'מנהל האיזור שלך יצור איתך קשר בקרוב',
		noKitsReported: 'לא נבחרו חוסרים',
	},
	en: {
		missing: "I'm missing products",
		notMissing: "I've received everything",
		modalTitle: 'We would like to know what you are missing',
		modalSubtitle: "so that we can provide the missing products as soon as possible",
		inputError: 'must be a reasonable positive number',
		submit: 'Submit',
		thanksTitle: 'Thanks for reporting!',
		thanksSubtitle: 'The manager of your region will contact you shortly',
		noKitsReported: 'No missing products were chosen',
	}
})